import React, {Component} from 'react';
import {Provider}         from 'react-redux';

import HomePage           from './pages/home/HomePage';
import store              from './store/store';
import                    './App.scss';

class App extends Component {

  render() {
    return (
      <Provider store={store}>
        <HomePage />
      </Provider>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js